import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Manifesto } from "@/components/home/Manifesto";
import { Chapters } from "@/components/home/Chapters";
import { Bento } from "@/components/home/Bento";
import { Collection } from "@/components/home/Collection";
import { Ritual } from "@/components/home/Ritual";
import { Caregivers } from "@/components/home/Caregivers";
import { ClosingCta } from "@/components/home/ClosingCta";
import { Seo } from "@/components/seo/Seo";
import { SEO } from "@/data/seo";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo {...SEO.home} />
      <Hero />
      <Marquee />
      <Manifesto />
      <Chapters />
      <Bento />
      <Collection />
      <Ritual />
      <Caregivers />
      <ClosingCta />
    </div>
  );
}
